// extracted by mini-css-extract-plugin
module.exports = {"collapsable":"styles-module__collapsable___2zi3_","preserve-newlines":"styles-module__preserve-newlines___3EBAI"};